<script>
    import FormBoxContainer from '$lib/components/UI/FormBoxContainer.svelte'
    import { SyncOutline } from '$lib/components/Icons'
    import {
        Row,
        Alert,
        Button,
        InputText,
        InputSearch,
        InputDate,
        Typography,
        MultiSelect,
    } from '$lib/components/UI'
    import { multiKeyFilter, isoDateFilter } from '$lib/services/dynamicFilters'
    import { getDateObj, getDiffDate, timeParse, strftime } from '$lib/utils'
    import { getNow } from '$lib/stores/device'
    import { default as filterIcon } from '../../../assets/pictures/f28-filter-funnel.svg'
    import dictionaries from '$lib/stores/dictionaries'
    import { Sucursal } from '$lib/services/interfaces'
    import { Close } from '$lib/components/Icons/custom'
    import { createEventDispatcher } from 'svelte'
    export let filters = []
    export let loading = false
    export let lastUpdate = null
    export let title = 'Mis Ofertas'
    let sucursales = []
    const now = getNow(5000) // Actualizar "now" cada 5 seg
    let estados = [
        { label: 'Ingresada', value: 'Ingresada' },
        { label: 'Rechazado', value: 'Rechazado' },
        { label: 'Adjudicada', value: 'Adjudicada' },
        { label: 'Remito adjuntado', value: 'Remito adjuntado' },
        { label: 'Entregado', value: 'Entregado' },
        { label: 'Devolucion', value: 'Devolucion' },
        { label: 'Factura adjuntada', value: 'Factura adjuntada' },
        { label: 'Finalizado', value: 'Finalizado' },
        { label: 'Solicitud de cambio de costo', value: 'Solicitud de cambio de costo' },
        { label: 'Pausada', value: 'Pausada' },
        { label: 'En Revisión', value: 'Revision Polaris' }
    ]//.map((x) => ({ label: x, value: x }))

    Sucursal.get().then((ret) => {
        if (ret.ok) {
            ret.json().then((r) => {
                console.log('RET', r)
                sucursales = r.map(({ nombre, uuid }) => ({
                    label: nombre,
                    value: uuid,
                }))
            })
        }
    })

    const dispatch = createEventDispatcher()

    function onSync(){
        dispatch('runSync')
    }

    let showFilter = false
    let data = {}
    let searchValue = ''

    function clearFilters() {
        searchValue = ''
        data = {}
        filters = []
    }

    $: marcas =
        $dictionaries?.lic_infoautos_marcas?.map(({ label }) => ({
            label,
            value: label,
        })) || []
    $: filters =
        searchValue !== ''
            ? [
                  multiKeyFilter(searchValue, [
                      'id_siniestro',
                      'codigo_infoauto',
                      'id_licitacion',
                      'vehiculo.marca',
                      'vehiculo.modelo',
                      'state',
                      'sucursal_nombre',
                      'monto_total',
                  ]),
              ]
            : [
                  [
                      data?.estados?.length > 0,
                      (items) =>
                          items.filter((item) =>
                              data.estados.includes(item?.state)
                          ),
                  ],
                  [
                      data?.sucursales?.length > 0,
                      (items) =>
                          items.filter((item) =>
                              data.sucursales.includes(item?.id_sucursal)
                          ),
                  ],
                  [
                      data?.marcas?.length > 0,
                      (items) =>
                          items.filter((item) =>
                              data.marcas.includes(item?.vehiculo?.marca)
                          ),
                  ],
                  [
                      data?.siniestro?.length > 0,
                      (items) =>
                          items.filter((item) =>
                              new RegExp(`^.*${data.siniestro}.*$`).test(
                                  item?.id_siniestro
                              )
                          ),
                  ],
                  [
                      data?.patente?.length > 0,
                      (items) =>
                          items.filter((item) =>
                              new RegExp(`^.*${data.patente}.*$`, 'i').test(
                                  item?.vehiculo?.patente
                              )
                          ),
                  ],
                  isoDateFilter([data.desde, data.hasta], 'creation_date'),
              ]
    $: validDates =
        data.desde && data.hasta
            ? getDateObj(data.desde)?.getTime() <=
              getDateObj(data.hasta)?.getTime()
            : true

</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<FormBoxContainer {title}>
    <svelte:fragment slot="option">
        <i style="font-size: 12px; color: var(--color-grey-800)">
            {#if loading}
                Actualizando...
            {:else}
                {#if lastUpdate}
                    {timeParse(getDiffDate($now, lastUpdate), 'Hace %-s segundos')}
                {/if}
            {/if}
        </i>
        <Button
            style="font-size: 13px; padding: 0"
            size="small"
            on:click={onSync}
            disabled={loading}
        ><SyncOutline rotate={loading} color="white"/>Actualizar</Button>
        <span
            style="cursor: pointer"
            on:click={(_) => {
                showFilter = !showFilter
                clearFilters()
            }}
        >
            {#if !showFilter}
                <img
                    src={filterIcon}
                    title="Filtros"
                    width="25px"
                    alt="Filtros"
                />
            {:else}
                <Close color="#C5281C" />
            {/if}
        </span>
    </svelte:fragment>
    {#if showFilter}
        <div style="padding: 30px">
            <Typography type="h5">Fecha de creación</Typography>
            <Row>
                <InputDate label="Desde" bind:value={data.desde} />
                <InputDate label="Hasta" bind:value={data.hasta} />
            </Row>
            {#if !validDates}
                <Alert type="Error">Rango de fechas incorrecto</Alert>
            {/if}
            <Row>
                <MultiSelect
                    maxItems={100000}
                    bind:value={data.sucursales}
                    label="Sucursal"
                    options={sucursales}
                    placeholder="Seleccionar Sucursal"
                />
                <MultiSelect
                    maxItems={100000}
                    bind:value={data.marcas}
                    label="Marca"
                    options={marcas}
                    placeholder="Seleccione una marca"
                />
            </Row>
            <Row>
                <MultiSelect
                    maxItems={100000}
                    bind:value={data.estados}
                    label="Estado"
                    options={estados}
                    placeholder="Seleccionar estados"
                />
            </Row>
            <Row>
                <InputText label="Siniestro" bind:value={data.siniestro} />
                <InputText label="Patente" bind:value={data.patente} />
            </Row>
        </div>
    {:else}
        <InputSearch bind:value={searchValue} />
    {/if}
</FormBoxContainer>
